import { Recurso, UnidadeRecursoSubstituto, Usuario } from 'eddydata-lib';
import { BaseResourceModel } from '../../models/base-resource.model';
import { Unidade } from '../planejamento/unidade.model';

export class UnidadeRecurso extends BaseResourceModel {
  constructor(
    public id?: number,
    public usuario?: Usuario,
    public aplicacao_variavel?: Recurso,
    public unidade?: Unidade,
    public cargo?: string,
    public unidade_recurso_substitutos?: UnidadeRecursoSubstituto[],
    public editavel?: boolean,
  ) {
    super();
  }
  static converteJson(json: any): UnidadeRecurso {
    return Object.assign(new UnidadeRecurso(), json);
  }
}
